import { ChangeDetectionStrategy, Component, ApplicationRef, ChangeDetectorRef, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, Events, AlertController, Content, Platform, LoadingController } from 'ionic-angular';
import { LoginProvider } from '../../providers/login/login';
import { AppState } from '../../config/state';
import { CoBookScannerPopoverComponent } from '../../components/co-book-scanner-popover/co-book-scanner-popover';
import { PopoverController } from 'ionic-angular/components/popover/popover-controller';
import { IlsProvider } from '../../providers/ils/ils';
import { ToastAlertsProvider } from '../../providers/toast-alerts/toast-alerts';
import { CoNgxKeyboardComponent } from '../../components/co-ngx-keyboard/co-ngx-keyboard';
import { TimeoutFunctionsProvider } from '../../providers/timeout-functions/timeout-functions';
import { CoEmailInputComponent } from '../../components/co-email-input/co-email-input';
import moment from 'moment';
import { MailProvider } from '../../providers/mail/mail';
import { NovelistProvider } from '../../providers/novelist/novelist';
import { PrintingProvider } from '../../providers/printing/printing';
import { CoSelfcheckAccountPage } from '../../pages/co-selfcheck-account/co-selfcheck-account';
import isIsbn from 'is-isbn';
import { HidScannerProvider } from '../../providers/hid-scanner/hid-scanner';

@IonicPage()
@Component({
  selector: 'page-co-selfcheck-checkout',
  templateUrl: 'co-selfcheck-checkout.html',
})
export class CoSelfcheckCheckoutPage {
  @ViewChild(Content) content: Content;
	private checkouts: any[] = [];
	private page: number = 1;
	private checkoutsRunning: number = 0;
	private osk: any;
	private queue: any;
	private checkoutStage: string = "loading";
	private novelistResults: any[] = [];
  private wideScreen: boolean;
  private menuSide = "right";
  private logoutTimer: number = 2000;
  private pagecount: any = 5;
  private pageAmount: number = 0;
  private patron : any;
  private prefillScan: string;
  private hidSubscription: any;
  private checkoutsTotalCost: number = 0;
  private fetchingItemDetails: number = 0;
  private loader: any;
	constructor(public navCtrl: NavController, public navParams: NavParams, private state:AppState, private loginProvider: LoginProvider, public popoverCtrl: PopoverController, private ilsProvider: IlsProvider, private toast:ToastAlertsProvider, private ref: ChangeDetectorRef, private events: Events, private timeout: TimeoutFunctionsProvider, private mailProvider:MailProvider, private novelist: NovelistProvider, private printingProvider: PrintingProvider, private platform : Platform, private alertCtrl: AlertController, private hidScanner: HidScannerProvider, private loading: LoadingController) {
    this.state.cordovaAvailable? this.pagecount = null : false; //REVERT THIS BEFORE PUSH
		this.events.subscribe('timeoutCalled', () => {
			this.timeout.doLogoutFunctions(this)
			// if (this.state.loggedInPatronId) this.loginProvider.instantLogout(this.logoutTimer);
		  });
	this.queue = Promise.resolve();
  if (this.state.patron && this.state.patron.barcode) this.patron = this.state.patron;
	this.events.subscribe('patronLoggedIn', (login)=>{
    this.content.resize();
    });
    this.wideScreen = this.platform.width() > 600 && (this.state.sharedScreen || this.state.staff || !this.state.cordovaAvailable);

    window.onresize = (e) => {
      this.wideScreen = this.platform.width() > 600 && (this.state.sharedScreen || this.state.staff || !this.state.cordovaAvailable);
    };
    window.onresize = (e) =>
    {
      setTimeout(() => {
        if (this.platform.width() > 600 && (this.state.sharedScreen || this.state.staff || !this.state.cordovaAvailable)) {
          this.wideScreen = true;
        } else if (this.platform.isLandscape() && (this.state.sharedScreen || this.state.staff || !this.state.cordovaAvailable)) {
          this.wideScreen = true;
        } else {
          this.wideScreen = false;
        }
      }, 225)

    };
  }

  get successfulCheckouts() {
	return  this.checkouts.filter(c=>c.status);
 }
	addToQueue(promise) {
		this.queue = this.queue.then(promise);
  	}
  ngOnInit(): void {
    this.state.novelistArray = [];
    this.checkouts = [];
	// this.checkouts.push({"status":false,"dueDate":null,"message":"This item cannot be checked out.  Please see a staff member for assistance.","item":{"itemIdentifier":"4004446629","titleIdentifier":"Hidden figures. / director, Theodore Melfi.","mediaType":null,"itemProperties":"","checkoutOk":false,"screenMessage":[]}});
	// this.checkouts.push({"status":true,"dueDate":"2019-06-18","message":null,"item":{"itemIdentifier":"4004394682","titleIdentifier":"It can't happen here / Sinclair Lewis ; with an introduction by Michael Meyer and a new afterword by","mediaType":null,"itemProperties":"","checkoutOk":true,"screenMessage":[]}});
	// this.checkouts.push({"status":true,"dueDate":"2019-06-18","message":null,"item":{"itemIdentifier":"4004394682","titleIdentifier":"It can't happen here / Sinclair Lewis ; with an introduction by Michael Meyer and a new afterword by","mediaType":null,"itemProperties":"","checkoutOk":true,"screenMessage":[]}});
	// this.checkouts.push({"status":true,"dueDate":"2019-06-18","message":null,"item":{"itemIdentifier":"4004394682","titleIdentifier":"It can't happen here / Sinclair Lewis ; with an introduction by Michael Meyer and a new afterword by","mediaType":null,"itemProperties":"","checkoutOk":true,"screenMessage":[]}});
	// this.checkouts.push({"status":true,"dueDate":"2019-06-18","message":null,"item":{"itemIdentifier":"4004394682","titleIdentifier":"It can't happen here / Sinclair Lewis ; with an introduction by Michael Meyer and a new afterword by","mediaType":null,"itemProperties":"","checkoutOk":true,"screenMessage":[]}});
	// this.checkouts.push({"status":true,"dueDate":"2019-06-18","message":null,"item":{"itemIdentifier":"4004394682","titleIdentifier":"It can't happen here / Sinclair Lewis ; with an introduction by Michael Meyer and a new afterword by","mediaType":null,"itemProperties":"","checkoutOk":true,"screenMessage":[]}});
	// this.checkouts.push({"status":true,"dueDate":"2019-06-18","message":null,"item":{"itemIdentifier":"4004394682","titleIdentifier":"It can't happen here / Sinclair Lewis ; with an introduction by Michael Meyer and a new afterword by","mediaType":null,"itemProperties":"","checkoutOk":true,"screenMessage":[]}});
	// this.checkouts.push({"status":true,"dueDate":"2019-06-18","message":null,"item":{"itemIdentifier":"4004394682","titleIdentifier":"It can't happen here / Sinclair Lewis ; with an introduction by Michael Meyer and a new afterword by","mediaType":null,"itemProperties":"","checkoutOk":true,"screenMessage":[]}});
	// this.checkouts.push({"status":true,"dueDate":"2019-06-18","message":null,"item":{"itemIdentifier":"4004394682","titleIdentifier":"It can't happen here / Sinclair Lewis ; with an introduction by Michael Meyer and a new afterword by","mediaType":null,"itemProperties":"","checkoutOk":true,"screenMessage":[]}});
	// this.checkouts.push({"status":false,"dueDate":null,"message":"item on hold","item":{"itemIdentifier":"4004446629","titleIdentifier":"Hidden figures. / director, Theodore Melfi.","mediaType":null,"itemProperties":"","checkoutOk":false,"screenMessage":[]}});
  // this.checkouts.push({"status":false,"dueDate":null,"message":"This item cannot be checked out.  Please see a staff member for assistance.","item":{"itemIdentifier":"4004446629","titleIdentifier":"Hidden figures. / director, Theodore Melfi.","mediaType":null,"itemProperties":"","checkoutOk":false,"screenMessage":[]}});

  // this.state.novelistArray.push({ // TEST OBJECT FOR NOVELIST DATA
  //   author: "Lewis, Sinclair",
  //   bibids: ["11242343"],
  //   description: "It is 1936. America has just elected Berzelius Windrip to the presidency-and his fascist policies turn the U.S. into a totalitarian state.",
  //   primaryISBN: "9780451216588",
  //   rating: 5,
  //   seriesInfo: null,
  //   similarTitles:[{title: "In our mad and furious city", author: "Gunaratne, Guy", rating: 2, primaryISBN: "9780374175771", reason: "These books share: the genre \"political fiction\"; and the subject \"extremism.\""},{title: "77", author: "Saccomanno, Guillermo", rating: 1, primaryISBN: "9781940953892", reason: "These books share: the genre \"political fiction\"; and the subject \"state-sponsored terrorism.\""},{title: "The eastern shore", author: "Just, Ward", rating: 2, primaryISBN: "9780544836587", reason: "These books share: the genre \"political fiction\"; and the subject \"newspaper editors.\""},{title: "How I became a North Korean", author: "Lee, Krys", rating: 2, primaryISBN: "9780670025688", reason: "These books share: the genre \"political fiction\"; and the subject \"state-sponsored terrorism.\""},{title: "The city always wins", author: "Hamilton, Omar Robert", rating: 2, primaryISBN: "9780374123970", reason: "These books share: the genre \"political fiction\"; and the subject \"state-sponsored terrorism.\""},{title: "The innocent have nothing to fear", author: "Stevens, Stuart", rating: 2, primaryISBN: "9780451493194", reason: "These books share: the genre \"political fiction\"; and the subject \"extremism.\""},{title: "Green Island", author: "Ryan, Shawna Yang", rating: 2, primaryISBN: "9781101874257", reason: "These books share: the genre \"political fiction\"; and the subject \"state-sponsored terrorism.\""},{title: "Taduno's song", author: "Atogun, Odafe", rating: 2, primaryISBN: "9781101871454", reason: "These books share: the genre \"political fiction\"; and the subject \"state-sponsored terrorism.\""},{title: "The blue line", author: "Betancourt, Ingrid", rating: 2, primaryISBN: "9781594206580", reason: "These books share: the genre \"political fiction\"; and the subject \"state-sponsored terrorism.\""},{title: "Hiding in plain sight", author: "Farah, Nuruddin", rating: 2, primaryISBN: "9781594633362", reason: "These books share: the genre \"political fiction\"; and the subject \"extremism.\""},{title: "The four books", author: "Yan, Lianke", rating: 2, primaryISBN: "9780802123121", reason: "These books share: the genre \"political fiction\"; and the subject \"state-sponsored terrorism.\""},{title: "The philosopher's flight", author: "Miller, Tom", rating: 3, primaryISBN: "9781476778150", reason: "These  share the subject \"Extremism.\""}],
  //   title: "It can't happen here"
  // })

  // ********* DUMMY DATA INCLUDED BELOW ************//

  // this.checkouts.push({"status":true,"dueDate":"2019-12-18","message":null,"item":{"itemIdentifier":"4004394682","titleIdentifier":"It can't happen here / Sinclair Lewis ; with an introduction by Michael Meyer and a new afterword by","mediaType":null,"itemProperties":"","checkoutOk":true,"screenMessage":[]}});

  // this.novelist.getItemDetailsFromBarcode('4004394682').then(result=>{
  //   // this.novelistResults.push(result);
  //   // console.log(result, checkout);
  //   this.state.novelistArray.push(result);
  // }).catch(err=>{});
  }

  ionViewWillEnter(): void {
    this.loginProvider.requireLogin(res=>{
      this.patron = res;
      if(this.navParams.get('scan')) {
        this.checkoutStage = 'checkout';
        this.checkoutBarcode(this.navParams.get('scan'));
      } else {
        this.showBookScannerPopup(true);
      }
      this.hidSubscription = this.hidScanner.scan.subscribe(value => {
        if(this.checkoutStage === 'checkout') this.checkoutBarcode(value);
      });
      this.hidScanner.start();
    }, false, false, true, this.prefillScan);
  }
  ionViewWillLeave(): void {
    if(this.hidSubscription) this.hidSubscription.unsubscribe();
    this.hidScanner.stop();
  }

  checkoutBarcode(barcode) {
    if(barcode.length === 13 && isIsbn.validate(barcode.toString())) {
      setTimeout(()=>this.toast.showAlert('','Error - Please scan the library barcode and not the ISBN number','warning',5000), 0);
    } else {
      this.addToQueue(() => this.checkoutBook(barcode));
    }
  }

  // ********* DUMMY DATA INCLUDED BELOW ************//
  checkoutDone(){
    if (this.state.staff){
      this.toast.showGenericConfirm('Email receipt to patron?').then(answer =>{
        if (answer === 1){
          this.sendReceipt('email', false);
        } else {
          this.instantLogout();
        }
      })
    } else {
      this.checkoutStage = 'done';
    }
    // console.log(this.state.novelistArray.length)
    // if (this.state.novelistArray.length <= 0){ //REMOVE THIS DATA BEFORE GO LIVE
    //   this.novelist.getItemDetailsFromBarcode('4004394682').then(result=>{
    //     this.state.novelistArray.push(result);
    //   }).catch(err=>{});
    // }
  }
  onDomChange(event){
		if (!this.state.cordovaAvailable){
      this.pagecount = Math.floor((event.target.clientHeight - 192)/101);
      this.calcPageAmount();
    }
  }
  calcPageAmount(){
    this.pageAmount = Math.ceil(this.checkouts.length / this.pagecount);
    console.log(this.pageAmount);
    return this.pageAmount;
  }
  checkoutDoneMobile(receipt, event?){
    if (receipt){
      let inputPopup;
      let customClass = 'custom-email-input-popover';
      let successfulItems = this.successfulCheckouts.length;
      inputPopup = this.popoverCtrl.create(CoEmailInputComponent, { inputType: 'email', email: this.patron.email }, { cssClass: customClass });
        let barcodeDetails, emailVars;
        let emailList = "";
        inputPopup.present({ ev: event || false });
        inputPopup.onDidDismiss(email => {
          if (email && email.info) {
            this.successfulCheckouts.forEach(checkout => {
            //   let status;
            //   book.bookPassed ? status = 'Passed' : status = 'Failed';
              emailList += `Title: ${checkout.item.titleIdentifier} \r\n Id: ${checkout.item.itemIdentifier} \r\n Due: ${moment(checkout.dueDate).format('MM/DD/YYYY')} \r\n \r\n`
            });
            if (this.patron.id) {
              barcodeDetails = `Customer ID: **********${this.patron.barcode.split('').reverse().slice(0, 4).reverse().join('')}`
            }
            emailVars = {
              first_name: '',
              screen_type: 'Checkout',
              branch_name: '',
              barcode_end: barcodeDetails || '',
              book_list: encodeURIComponent(emailList),
              // book_list: emailList,
              past_tense: 'checked out',
              total: successfulItems
            }
            this.patron && this.patron.firstName ? emailVars.first_name = this.patron.firstName : emailVars.first_name = '';
            this.mailProvider.sendBookReceipt(email.info, emailVars, true).then(res => {
              if (res.status) {
                this.toast.showAlert('', 'Your receipt has been sent!', 'success', 5000);
                this.navCtrl.pop();
              } else {
                this.toast.triggerToast('Send failed, please retry', '');
              };
            });
          }
        });
    } else {
      this.navCtrl.pop();
    }
  }



  showBookScannerPopup(stopPop) {
    let customClass = 'custom-barcode-scanner-popover';
    let popover = this.popoverCtrl.create(CoBookScannerPopoverComponent, { type: 'book', stopNavPop: stopPop, scope: 'checkout' }, { cssClass: customClass });

    if (this.state.cordovaAvailable){

      popover.present({
        ev: '',
        animate: false
      });

      popover.onDidDismiss(data => {
      this.checkoutStage = 'checkout';
        if (data && data.info) {
          this.checkoutBarcode(data.info);
        }else if(this.checkouts.length === 0){
      //   this.logout();
      }
      });
    } else {
      this.checkoutStage = 'checkout';
    }

  }
  openCamera(){
    let lintWindow: any = window;
    if(lintWindow.cordova && lintWindow.cordova.plugins) {
      lintWindow.cordova.plugins.CoScanner.scan({
        color: "#ff00ff",
        message: "Please scan a library item barcode",
        isISBN: false
      }, (data) => {
        if (data.success == true) {
          this.addToQueue(()=>this.checkoutBook(data.result));
        }
      }, (error) => {
        if (error.error != 'USER_CANCELLED') {
          this.toast.showAlert('', error.message);
        }
      });
    }
  }
  typeInBarcode(){
    let inputPopup = this.popoverCtrl.create(CoEmailInputComponent, { inputType: 'barcode' }, { cssClass: 'custom-email-input-popover' });
    inputPopup.present();
    inputPopup.onDidDismiss(data => {
      if (data && data.info) {
        this.checkoutBarcode(data.info);
      }
    });
  }
  showScanner(){
    if(this.state.enableOnScreenKeyboard){
      this.osk = this.popoverCtrl.create(CoNgxKeyboardComponent, {mode: 'standalone'}, {cssClass: "custom-keyboard-popover-bottom"});
      this.osk.present();
      this.osk.onDidDismiss(data => {
        if(data && data.length>0){
          this.checkoutBarcode(data);
        }
      });
    }
  }
  getItemCost(barcode: string) {
    this.fetchingItemDetails ++;
    this.ilsProvider.getItemFromBarcode(barcode).then( (item:any) => {
      this.fetchingItemDetails --;
      if(item && item.cost) {
        this.checkoutsTotalCost += item.cost;
      }
    }).catch( () => {
      this.fetchingItemDetails --;
    });
  }
  awaitItemDetails(callback) {
    if(this.fetchingItemDetails > 0) {
      if(!this.loader) {
        this.loader = this.loading.create({content: 'Retrieving item information...'});
        this.loader.present();
      }
      setTimeout( () => {
        this.awaitItemDetails(callback);
      }, 200);
    } else {
      if(this.loader) {
        this.loader.dismiss();
        this.loader = null;
      }
      callback();
    }
  }
	private checkoutBook(barcode):Promise<Boolean>{
		if(!barcode||barcode==="")return;
    if (this.checkouts.findIndex(b => b.item.itemIdentifier === barcode) === -1) {
	  this.checkoutsRunning++;
	  if(this.state.demo){
		  return this.ilsProvider.getBibDetailsFromBarcode(barcode).then(bib=>{
			this.checkoutsRunning--;
			  if(bib){
          if(bib.isbns && bib.isbns.length>0){
            this.novelist.getItemDetailsFromISBN(bib.isbns[0]).then(result=>{
              if (result) this.state.novelistArray.push(result);
            }).catch(err=>{});
          }
          this.checkouts.push({"status":true,
          "dueDate": moment().add(30, 'days').format('YYYY-MM-DD'),
          "message":null,
          "item":{"itemIdentifier":barcode,
          "titleIdentifier":bib.title,
          "mediaType":null,
          "itemProperties":"",
          "checkoutOk":true,
          "screenMessage":[]}});
          this.getItemCost(barcode);
          this.playSound(true);
          return true;
        }else{
          this.playSound(false);
          return false;
        }
      }).catch(err=>{
        this.playSound(false);
        return false;
      });
	  }else{
		return this.ilsProvider.checkoutBook(this.patron.barcode, barcode, this.state.locationId.toString(), this.patron.pin).then(checkout => {
			try{
				this.checkoutsRunning--;
				// this.checkouts.unshift(null);
				if(checkout && checkout.item){
					this.checkouts.unshift(checkout);
					if (checkout.status) {
						if (this.state.patron) this.state.patron.changedItems.push({
						"type":"checkout",
						"id": barcode,
						"dueDate": checkout.dueDate,
						"bib": {
							"id":barcode,
							"title":checkout.item.titleIdentifier,
							"format":checkout.item.mediaType,
							"author":""
						}
						});
						this.playSound(true);
						if(this.state.hasNovelist){
							this.novelist.getItemDetailsFromBarcode(barcode).then(result=>{
								// this.novelistResults.push(result);
								if (result && result.title !== null) this.state.novelistArray.push(result);
							}).catch(err=>{});
						}
						this.getItemCost(barcode);
						return true;
					} else {
					this.playSound(false);
					return false;
					}
				}else{
					console.log(`checking out ${barcode} for ${this.patron.barcode} failed`);
					this.toast.triggerToast("There was a problem checking out this item, please try again", '', 'error', 6000);
					this.playSound(false);
					return false;
				}
			}catch(err){
        this.checkoutsRunning--;
				console.error(err);
				this.playSound(false);
				return false;
			}
		  });
	  }
    } else {
		// console.log(`Item already checked out: ${barcode}`);
      this.toast.triggerToast("You have already checked out this item!", '', 'warning', 6000);
    }
    if (!this.state.cordovaAvailable) this.page = this.pageAmount;
  }
  myAccount(){
	this.state.nav.push(CoSelfcheckAccountPage);
  }
  closeCheckout(logout:Boolean){
	  if(this.successfulCheckouts.length===0 || this.checkoutStage === 'done'){
		  if(logout){
			  this.logout();
		  }else{
			this.state.nav.popToRoot();
		  }
		  return;
	  }
	let alert = this.alertCtrl.create({
		title: 'Close checkout',
		cssClass:'confirm-alert',
		message: 'Before you log out, do you want a receipt for your checkouts?',
		buttons: [
		  {
			text: 'No',
			role: 'cancel',
			cssClass: 'confirm-button-outline',
			handler: () => {
				if(logout){
					this.logout();
				}else{
				  this.state.nav.popToRoot();
				}
			  return;
			}
		  },
		  {
			text: 'Yes',
			cssClass: 'confirm-button',
			handler: () => {
			  this.checkoutDone();
			}
		  }
		]
	  });
	  alert.present();
  }
  logout() {
	let alert = this.alertCtrl.create({
		title: 'Logout',
		cssClass:'confirm-alert',
		message: 'Do you want to log out?',
		buttons: [
		  {
			text: 'No',
			role: 'cancel',
			cssClass: 'confirm-button-outline',
			handler: () => {
			  return;
			}
		  },
		  {
			text: 'Yes',
			cssClass: 'confirm-button',
			handler: () => {
				this.instantLogout();
			}
		  }
		]
	  });
	  alert.present();
  }
  instantLogout() {
    if (this.state.staff){
      this.state.nav.popToRoot();
    } else {
      this.loginProvider.logout(this.logoutTimer).then( done =>{
        if( done ){
          this.state.nav.popToRoot();
        }
      });
    }
  }
  playSound(status){
    if (this.state.enableSounds) {
      const sound = status?new Audio('assets/sounds/checkoutsuccess.mp3'):new Audio('assets/sounds/checkoutfailed.mp3');
      sound.loop = false;
      sound.play();
    }
  }
  sendReceipt(notification, event) {
    let inputPopup;
    let customClass = 'custom-email-input-popover';
    let successfulItems = this.successfulCheckouts.length;

    if (this.state.customStrings.checkout && this.state.customStrings.checkout.customLogoutMsg){
      this.state.logoutSummary = this.state.customStrings.checkout.customLogoutMsg;
      this.logoutTimer = 6000;
    } else {
      this.state.logoutSummary = "";
      this.logoutTimer = 2000;
    }
    // console.log(this.state.customStrings.checkout, this.state.logoutSummary);

    switch (notification) {
      case ('email'):
        inputPopup = this.popoverCtrl.create(CoEmailInputComponent, {
          inputType: 'email',
          email: this.patron && this.patron.email ? this.patron.email : ''
        }, { cssClass: customClass });
        let barcodeDetails, emailVars;
        let emailList = "";
        inputPopup.present({ ev: event });
        inputPopup.onDidDismiss(email => {
          if (email && email.info) {
            this.successfulCheckouts.forEach(checkout => {
            //   let status;
            //   book.bookPassed ? status = 'Passed' : status = 'Failed';
              emailList += `Title: ${checkout.item.titleIdentifier} \r\n Id: ${checkout.item.itemIdentifier} \r\n Due: ${moment(checkout.dueDate).format('MM/DD/YYYY')} \r\n \r\n`
            });
            if (this.patron.id) {
              barcodeDetails = `Customer ID: **********${this.patron.barcode.split('').reverse().slice(0, 4).reverse().join('')}`
            }
            emailVars = {
              first_name: '',
              screen_type: 'Checkout',
              branch_name: '',
              barcode_end: barcodeDetails || '',
              book_list: encodeURIComponent(emailList),
              // book_list: emailList,
              past_tense: 'checked out',
              total: successfulItems
            }
            this.patron && this.patron.firstName ? emailVars.first_name = this.patron.firstName : emailVars.first_name = '';
            this.mailProvider.sendBookReceipt(email.info, emailVars, true).then(res => {
              if (res.status) {
                this.toast.showAlert('', 'Your receipt has been sent!', 'success', 3000);
                this.instantLogout();
              } else {
                this.toast.triggerToast('Send failed, please retry', '');
              };
            });
          }
        });
        break;
      case ('phone'):
        inputPopup = this.popoverCtrl.create(CoEmailInputComponent, { inputType: 'phone' }, { cssClass: customClass });
        inputPopup.present({ ev: event });
        inputPopup.onDidDismiss(phone => {
          if (phone && phone.info) {
            // console.log(this.patron.firstName)
            this.mailProvider.sendBookReceipt(`1${phone.info}`, { first_name: this.patron.firstName || "", screen_type: 'check out', branch_name: this.state.branchInformation.name, total: successfulItems }, false).then(res => {
              if (res.status) {
                this.toast.triggerToast('Your receipt has been sent!', '', 'success', 3000);
              } else {
                this.toast.triggerToast('Send failed, please retry', '');
              }
            });
          }
        });
        break;
      case ('print'):
        // console.log(this.successfulCheckouts)
        // let preview = this.popoverCtrl.create(CoPrintPreviewPopoverComponent, { receiptInfo: this.successfulCheckouts, screenType: 'Checkout', patron: this.state.patron, pastTense: 'checked out', submitTime: moment(), idents: [] });
        // preview.present();
        this.awaitItemDetails( () => {
          this.printingProvider.printCheckoutItemReceipt({ receiptInfo: this.successfulCheckouts, screenType: 'Checkout', patron: this.patron, pastTense: 'checked out', submitTime: moment(), novelistResults: this.novelistResults, totalCost: this.checkoutsTotalCost }, false, this.logoutTimer);
        });
        break;
      default:
        this.instantLogout();
      break;
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/co-selfcheck-checkout/co-selfcheck-checkout.ts